import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Renderer2,
} from "@angular/core";
import { LayoutService } from "./core/layout.service";
import { LayoutInitService } from "./core/layout-init.service";
import { SidebarService } from "./core/sidebar.service";
import { Observable, filter, map, switchMap, tap } from "rxjs";
import { PageInfoService } from "./core/page-info.service";
import { EditModeService } from '@lcms/shared/edit-mode';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { UserService } from "@lcms/shared/data-access-user";
import {EchoChannelService} from "@lcms/shared/notififications";
import { TranslationService } from "@lcms/shared/i18n";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  // Public variables
  modeEditColor = '#dc3545';
  initialColor: string;

  isEditMode$ = this.editmodeservice.isEditMode$;
  selfLayout = "default";
  asideSelfDisplay: true;
  asideMenuStatic: true;
  contentClasses = "";
  contentContainerClasses = "";
  toolbarDisplay = true;
  contentExtended: false;
  asideCSSClasses: string;
  asideHTMLAttributes: any = {};
  headerMobileClasses = "";
  headerMobileAttributes = {};
  footerDisplay: boolean;
  headerFixedDesktop?: boolean = false;
  footerCSSClasses: string;
  headerCSSClasses: string;
  headerHTMLAttributes: any = {};
  showSidebar$: Observable<boolean>;
  // offcanvases
  extrasSearchOffcanvasDisplay = false;
  extrasNotificationsOffcanvasDisplay = false;
  extrasQuickActionsOffcanvasDisplay = false;
  extrasCartOffcanvasDisplay = false;
  extrasUserOffcanvasDisplay = false;
  extrasQuickPanelDisplay = false;
  extrasScrollTopDisplay = false;
  asideDisplay: boolean;
  title$: Observable<string>;

  @ViewChild("ktAside", { static: true }) ktAside: ElementRef;
  @ViewChild("ktHeaderMobile", { static: true }) ktHeaderMobile: ElementRef;
  @ViewChild("ktHeader", { static: true }) ktHeader: ElementRef;
  editableRoutes = [
    '/formation',
    '/dashboard',
    '/document',
  ]
  modeEdit$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map((event) => {
      const navigationEndEvent = event as NavigationEnd;
      // return this.editableRoutes.includes(navigationEndEvent.urlAfterRedirects);
      return true
    })
  );
  isHovering = false;

  isHomeRoute = false;
  constructor(
    private initService: LayoutInitService,
    private layout: LayoutService,
    private sidebar: SidebarService,
    private pageInfo: PageInfoService,
    private editmodeservice: EditModeService,
    private renderer: Renderer2,
    private el: ElementRef,
    private readonly router: Router,
    private userService:UserService,
    private echo : EchoChannelService,
    private translationService:TranslateService
  ) {
    this.initService.init();
    this.showSidebar$ = this.sidebar.sidebarState.asObservable();
    this.getOFAG();
  }

  lang$ = this.translationService.onLangChange.asObservable();
  OFAG;

  canAccess$:Observable<boolean> = this.userService.getUserRole$.pipe(
    tap(res => console.log("layount component can access", res)),
    map(role => ['administrator','manager','tutor'].includes(role)))

    async getOFAG() {
      try {
        const clientModule = await import('client/src/app.config');
        this.OFAG = (clientModule as any)?.customLayout.OFAG || false;
      } catch (error) {
        // console.error('Failed to load allowedViewTypes from @client', error);
      }
    }
  ngOnInit(): void {
    console.log("layount component oninit");

    this.isHomeRoute = this.router.url === '/';
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    ).subscribe((event: NavigationEnd) => {
      this.isHomeRoute = event.urlAfterRedirects === '/';
    });
    // build view by layout config settings
    this.echo.getInterests().subscribe()
    this.asideDisplay = this.layout.getProp("aside.display") as boolean;
    this.toolbarDisplay = this.layout.getProp("toolbar.display") as boolean;
    this.headerFixedDesktop = this.layout.getProp("header.fixed.desktop") as
      | boolean
      | undefined;
    this.contentContainerClasses = this.layout.getStringCSSClasses("contentContainer");
    this.asideCSSClasses = this.layout.getStringCSSClasses("aside");
    this.headerCSSClasses = this.layout.getStringCSSClasses("header");
    this.headerHTMLAttributes = this.layout.getHTMLAttributes("headerMenu");
    this.footerCSSClasses = this.layout.getStringCSSClasses("footer");
    this.title$ = this.pageInfo.title.asObservable();
    this.initialColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--bs-primary').trim();
  }
  // private applyColor(color: string): void {
  //   const cssText = `:root { --bs-primary: ${color}; --bs-primary-active:${color};}`;
  //   this.injectStyles(cssText);
  // }

  private injectStyles(cssText: string): void {
    const styleElement = document.createElement('style');
    styleElement.textContent = cssText;
    document.head.appendChild(styleElement);
  }

  ngAfterViewInit(): void {
    if (this.ktHeader) {
      for (const key in this.headerHTMLAttributes) {
        if (this.headerHTMLAttributes.hasOwnProperty(key)) {
          this.ktHeader.nativeElement.attributes[key] =
            this.headerHTMLAttributes[key];
        }
      }
    }
      // this.renderer.setStyle(this.el.nativeElement.ownerDocument.documentElement, '--bs-primary', '#dc3545');

  }
  editMode(){
    this.editmodeservice.toggleEditMode();
  }
  hover(isHovering: boolean) {
    this.isHovering = isHovering;
  }
}
